import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { StyleHTMLAttributes } from 'react';
import styled from 'styled-components';

/**
 * Font Awesome Free 5.5.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */

interface Props {
  className?: string;
  style?: StyleHTMLAttributes<any>;
}

const ExternalLinkIcon = ({ className, style }: Props) => {
  return (
    <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z" />
    </svg>
  );
};
const SmallExternalLinkIcon = styled(ExternalLinkIcon)<{
  color?: string;
  size?: number;
}>`
  display: inline-block;
  fill: ${props => (props.color ? props.color : BouColor.TOOL_TEXT_GRAY)};
  width: ${props => (props.size ? props.size : '14')}px;
  height: ${props => (props.size ? props.size : '14')}px;
  margin-left: 2px;
  position: relative;
  top: 1px;
  cursor: pointer;
  &:hover {
    fill: ${BouColor.TOOL_TEXT_DARK_GRAY};
  }
`;

export default SmallExternalLinkIcon;
